// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__GaYg8","animatedImage":"Logo_animatedImage__KLTmX","zoomOut":"Logo_zoomOut__8XqFR","image":"Logo_image__jvSWr","text":"Logo_text__hZM1C"};